import React from 'react';
import { connect } from 'react-redux';
import { Box, DataTable } from '../../../../common/components';
import { applyFilter } from '../../../../common/components/DataTable/redux/dataTableActions';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { FormControl, Row, Col } from 'react-bootstrap';
import { push } from 'react-router-redux';
import {
  getBrokerId,
  hasPermission,
  isBroker,
  isBrokerOrganisation,
  isOwner,
} from '../../../auth/redux/authActions';
import StatusFilter from '../StatusFilter/StatusFilter';
import formatDateTime from '../../../../helpers/formatDateTime';
import AsyncSelectMenu from '../../../../common/components/SelectMenu/AsyncSelectMenu';
import Loader from '../../../../common/components/Loader/Loader';
import FilterContainer from '../FilterContainer/FilterContainer';

const MtaList = ({ location, goTo, applyFilter }) => {
  const status = location?.query.status ?? 'applied,quote,issued';
  const handleRowClick = (row) => {
    goTo(`/policies/applications/${row.id}`);
  };

  const handleSearchUpdate = (e) => {
    applyFilter('mtas', 'filter[quote.reference]', e.target.value);
  };

  const handleBrokerUpdate = (option) => {
    applyFilter('mtas', 'filter[broker]', option ? option.value : '');
  };

  const handleUserUpdate = (option) => {
    applyFilter('mtas', 'filter[user]', option ? option.value : '');
  };

  const handleStatusFilterUpdate = (option) => {
    applyFilter('mtas', 'filter[status]', option ? option.value : '');
  };

  if (!status) {
    return <Loader />;
  }
  const autoFilters = [
    { type: 'filter[status]', value: status },
    { type: 'filter[quote.type]', value: 'mid term adjustment' },
  ];

  const colSize = isBrokerOrganisation() ? 3 : 4;

  if (isBroker()) {
    autoFilters.push({ type: 'filter[broker]', value: getBrokerId() });
  }

  return (
    <div>
      <Box>
        <Row>
          <Col sm={3}>
            <FilterContainer label={'Reference'}>
              <FormControl onChange={handleSearchUpdate} />
            </FilterContainer>
          </Col>
          {isOwner() && hasPermission('broker.view') && (
            <Col sm={3}>
              <FilterContainer label={'Broker'}>
                <AsyncSelectMenu
                  url={'/brokers?'}
                  optionValuePath={'id'}
                  onChangeCallback={handleBrokerUpdate}
                  isClearable
                />
              </FilterContainer>
            </Col>
          )}
          {(isOwner() || isBroker() || isBrokerOrganisation()) &&
            hasPermission('user.view') && (
              <Col sm={3}>
                <FilterContainer label={'User'}>
                  <AsyncSelectMenu
                    url={'/users?'}
                    optionValuePath={'id'}
                    labelPath={'attributes.full_name'}
                    onChangeCallback={handleUserUpdate}
                    isClearable
                  />
                </FilterContainer>
              </Col>
            )}

          <Col sm={3}>
            <FilterContainer label={'Status'}>
              <StatusFilter onChange={handleStatusFilterUpdate} isClearable />
            </FilterContainer>
          </Col>
          {isBrokerOrganisation() && (
            <Col sm={colSize}>
              <FilterContainer label={'Branch'}>
                <AsyncSelectMenu
                  url={'/brokers?'}
                  optionValuePath={'id'}
                  onChangeCallback={handleBrokerUpdate}
                  isClearable
                />
              </FilterContainer>
            </Col>
          )}
        </Row>
      </Box>

      <Box>
        <DataTable
          source="local/policies/applications"
          name="mtas"
          autoFilters={autoFilters}
          showTotal
          onRowSelect={handleRowClick}
        >
          <TableHeaderColumn dataField="id" isKey hidden />

          <TableHeaderColumn dataField="quote_reference" width={'11%'}>
            Reference
          </TableHeaderColumn>

          <TableHeaderColumn dataField="mta_policy_number" width={'15%'}>
            Policy Number
          </TableHeaderColumn>

          <TableHeaderColumn dataField="insured" width={'15%'}>
            Insured
          </TableHeaderColumn>

          <TableHeaderColumn dataField="channel_name" width={'10%'}>
            Channel
          </TableHeaderColumn>

          <TableHeaderColumn dataField="broker_name" width={'14%'}>
            Broker
          </TableHeaderColumn>

          <TableHeaderColumn dataField="user_name" width={'15%'}>
            User
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="created_at"
            dataFormat={formatDateTime}
            dataSort
            width={'12%'}
          >
            Quote Date
          </TableHeaderColumn>

          <TableHeaderColumn dataField="status" dataSort width={'6%'}>
            Status
          </TableHeaderColumn>
        </DataTable>
      </Box>
    </div>
  );
};

export default connect(
  (state) => ({
    auth: state.auth,
  }),
  {
    goTo: push,
    applyFilter: applyFilter,
  },
)(MtaList);
